import React from "react";
import { useTranslation } from "react-i18next";
import { useFormikContext } from "formik";
import InputFieldFloat from "../../inputs/InputFieldFloat";
import PasswordInputFloat from "../../inputs/PasswordInputFloat";
import PhoneInput from "../../inputs/PhoneInput";

const AccountInfoStep = () => {
  const { t } = useTranslation("signup");
  const { values, errors, touched, handleChange, setFieldValue } = useFormikContext();

  return (
    <div className="field-row i-mb-8">
      <div className="field-block">
        <InputFieldFloat
          label={t("first_name")}
          floating={true}
          name="firstName"
          value={values.firstName}
          onChange={handleChange}
          error={errors.firstName}
          touched={touched.firstName}
          required={true}
        />
      </div>
      <div className="field-block">
        <InputFieldFloat
          label={t("last_name")}
          floating={true}
          name="lastName"
          value={values.lastName}
          onChange={handleChange}
          error={errors.lastName}
          touched={touched.lastName}
          required={true}
        />
      </div>
      <div className="field-block grid-full">
        <InputFieldFloat
          label={t("email")}
          floating={true}
          name="email"
          value={values.email}
          onChange={handleChange}
          error={errors.email}
          touched={touched.email}
          type="email"
          required={true}
        />
      </div>
      <div className="field-block grid-full phone-number-field">
        <div className="phone-number-field">
          <InputFieldFloat
            label={t("phone")}
            floating={true}
            name="phone"
            type="tel"
            value={values.phone}
            onChange={handleChange}
            error={errors.phone}
            touched={touched.phone}
            required={true}
          />
        </div>
        <PhoneInput
          name="countryCode"
          value={values.countryCode}
          onChange={(value) => {
            setFieldValue("countryCode", value);
          }}
        />
      </div>
      <div className="field-block grid-full">
        <PasswordInputFloat
          label={t("password")}
          floating={true}
          name="password"
          value={values.password}
          onChange={handleChange}
          error={errors.password}
          touched={touched.password}
          type="password"
          required={true}
          Autocomplete={false}
        />
      </div>
    </div>
  );
};

export default AccountInfoStep;
